var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.371,
    height: 51.921,
    viewBox: "0 0 53.371 51.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_22",
    "data-name": "Intersection 22",
    d: "M49.042,51.921a3.966,3.966,0,0,1-2.832-1.161l-7.978-7.978.924-.924-2.107-2.107a22.558,22.558,0,1,1,3.963-4.342l2.3,2.3.925-.925,7.977,7.978a3.972,3.972,0,0,1,1.16,2.935,4.369,4.369,0,0,1-4.226,4.226Zm-8.8-9.116L47.2,49.768a2.569,2.569,0,0,0,1.91.749,2.964,2.964,0,0,0,2.856-2.856,2.581,2.581,0,0,0-.75-1.91l-6.963-6.963ZM1.4,22.534A21.132,21.132,0,1,0,22.535,1.4,21.156,21.156,0,0,0,1.4,22.534Zm36.927,16.3,1.841,1.84,1.955-1.954L40.284,36.88ZM4.491,22.534A18.043,18.043,0,1,1,22.535,40.577,18.063,18.063,0,0,1,4.491,22.534Zm1.4,0A16.641,16.641,0,1,0,22.535,5.894,16.659,16.659,0,0,0,5.893,22.534ZM21.833,29.2V26.952a4.479,4.479,0,0,1-3.716-3.716H15.87a.7.7,0,0,1,0-1.4h2.247a4.48,4.48,0,0,1,3.716-3.716V15.87a.7.7,0,0,1,1.4,0v2.246a4.482,4.482,0,0,1,3.717,3.716H29.2a.7.7,0,0,1,0,1.4H26.953a4.481,4.481,0,0,1-3.717,3.716V29.2a.7.7,0,0,1-1.4,0Zm-2.375-6.665a3.076,3.076,0,1,0,3.077-3.075A3.08,3.08,0,0,0,19.458,22.534Zm-9.93-1.267a.7.7,0,0,1-.589-.8A13.74,13.74,0,0,1,20.886,8.889a.7.7,0,1,1,.165,1.393A12.339,12.339,0,0,0,10.324,20.677a.7.7,0,0,1-.691.6A.836.836,0,0,1,9.528,21.267Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.d44649796abd68a5029552f382c5cfb4.svg";
export { ForwardRef as ReactComponent };